export default __webpack_public_path__ + "static/media/ct4.1.e3130c19.png";